import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities' 
import router from '../router';

class BrokerAccountRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    addApiCredential(apiCredential) {
        let headers = {'Authorization': store.state.token ? store.state.token : `Bearer ${router.currentRoute.query.token}` };
        let response = axios.post(`${this.basePath}/ext/broker-account-api-credential/add-to`, apiCredential,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
    getPADomain(countryCode) {
        let headers = {'Authorization': store.state.token ? store.state.token : `Bearer ${router.currentRoute.query.token}`};
        let response = axios.get(`${this.basePath}/ext/broker-account-api-credential/exness/pa-domain/${countryCode}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new BrokerAccountRepository();
